import useInterval from './interval';
import useKeypress from './keypress';

export default {
  useInterval,
  useKeypress,
};
